<template>
  <div class="modalWrapper">
    <div class="modalBlock">
      <div>
        <div class="confirmHeader">
          {{ header }}
        </div>
        <div class="confirmTitle" v-html="title"></div>
      </div>
      <div class="actionWrapper">
        <div class="confirmActions">
          <div class="confirmBtn cancelButton" @click="close">
            {{ getButtonTextDeny }}
          </div>
          <div class="confirmBtn" @click="confirm">
            {{ getButtonTextApprove }}
          </div>
        </div>
      </div>
    </div>
    <div class="modalBackdrop"></div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    header: String,
    button_text_approve: String,
    button_text_deny: String,
    onConfirm: Function,
    onClose: Function
  },
  computed: {
    getButtonTextApprove() {
      if (this.button_text_approve) {
        return this.button_text_approve;
      } else {
        return this.$t("dialog.confirm.btn.approve");
      }
    },
    getButtonTextDeny() {
      if (this.button_text_deny) {
        return this.button_text_deny;
      } else {
        return this.$t("dialog.confirm.btn.deny");
      }
    }
  },
  methods: {
    close() {
      this.$emit("onClose");
    },
    confirm() {
      this.$emit("onConfirm");
    }
  }
};
</script>
<style lang="scss" scoped>
.modalWrapper {
  height: 100vh;
  width: 100vw;
  background: rgba(37, 37, 37, 0.12);
  position: fixed;
  z-index: 1200;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.modalBackdrop {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 1250;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.modalBlock {
  position: fixed;
  z-index: 1300;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 550px auto;
  width: 750px;
  height: 381px;
  background: #fff 0% 0% no-repeat padding-box;
  box-shadow: 4px 4px 25px #00000033;
  border-radius: var(--component_modals_confirm_modalBlock_border-radius);
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 95px 30px 75px 30px;
  color: black;
  justify-content: flex-start;
}
.actionWrapper {
  display: flex;
  justify-content: center;
}
.confirmActions {
  display: flex;
  justify-content: space-around;
  width: 75%;
}
.confirmBtn {
  width: 210px;
  height: 70px;
  border: var(--component_modals_confirm_confirmBtn_border);
  border-radius: var(--component_modals_confirm_confirmBtn_border-radius);
  color: var(--component_modals_confirm_confirmBtn_color);
  font-size: var(--component_modals_confirm_confirmBtn_font-size);
  line-height: var(--component_modals_confirm_confirmBtn_font-size);
  text-align: center;
  text-transform: var(--component_modals_confirm_confirmBtn_text-transform);
  padding: var(--component_modals_confirm_confirmBtn_padding);
  letter-spacing: 1px;
  font-family: var(--component_modals_confirm_confirmBtn_font-family);
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--component_modals_confirm_confirmBtn_background);
}

.cancelButton {
  background: var(--component_modals_confirm_cancelBtn_background);
  color: var(--component_modals_confirm_cancelBtn_color);
}

.confirmTitle {
  color: var(--component_modals_confirm_confirmTitle_color);
  font-size: var(--component_modals_confirm_confirmTitle_font-size);
  font-family: var(--component_modals_confirm_confirmTitle_font-family);
  font-weight: var(--component_modals_confirm_confirmTitle_font-weight);
  padding-bottom: 50px;
  line-height: 28px;
}
.confirmHeader {
  color: var(--component_modals_confirm_confirmHeader_color);
  font-size: var(--component_modals_confirm_confirmHeader_font-size);
  font-family: var(--component_modals_confirm_confirmHeader_font-family);
  text-transform: var(--component_modals_confirm_confirmHeader_text-transform);
  padding-bottom: 10px;
}
</style>
